import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { SUPPORTED_LANGS, DEFAULT_LANG, langFromPath } from './index';

/**
 * Antepone il prefisso lingua a un path applicativo.
 * IT (default) = nessun prefisso; EN = /en/...
 * @param {string} path es. "/platform" oppure "/"
 * @param {string} lang "it" | "en"
 */
export function localizePath(path, lang) {
  const clean = path.startsWith('/') ? path : `/${path}`;
  if (lang === DEFAULT_LANG) return clean;
  if (clean === '/') return `/${lang}`;
  return `/${lang}${clean}`;
}

/** Rimuove il prefisso lingua da un pathname → path applicativo "neutro". */
export function stripLangPrefix(pathname) {
  const parts = pathname.split('/').filter(Boolean);
  if (SUPPORTED_LANGS.includes(parts[0]) && parts[0] !== DEFAULT_LANG) {
    const rest = '/' + parts.slice(1).join('/');
    return rest === '/' ? '/' : rest.replace(/\/$/, '');
  }
  return pathname === '' ? '/' : pathname;
}

/** Lingua corrente derivata dall'URL. */
export function useLang() {
  const { pathname } = useLocation();
  return langFromPath(pathname);
}

/** Restituisce una funzione che localizza un path nella lingua corrente. */
export function useLocalize() {
  const lang = useLang();
  return useCallback((path) => localizePath(path, lang), [lang]);
}

/** URL della pagina corrente nell'altra lingua (per lo switcher). */
export function useSwitchLangPath(targetLang) {
  const { pathname, search, hash } = useLocation();
  const neutral = stripLangPrefix(pathname);
  return localizePath(neutral, targetLang) + search + hash;
}
